import { set, cloneDeep } from "lodash"

export const evaluateFormulas = context => (input, extraData) => {
    var string = input
    var wasObject
    if (typeof string === "object" || Array.isArray(string)) {
        wasObject = true
        string = JSON.stringify(string)
    }
    if (!string) {
        return string
    }
    if (string.indexOf("foo") !== -1) debugger
    //    string = String(string)
    const re = /({(block|input|data|record|user|query|url).*?})/g
    const matches = string.match(re)
    if (matches && matches.length) {
        matches.forEach(match => {
            // Remove the { }
            try {
                const formula = match.slice(1, match.length - 1)
                var user = JSON.parse(localStorage.getItem("user") || "{}")
                var record = context.record
                var query = context.query
                var url = context.url
                var input = context.input
                var data = extraData
                var block = {}
                Object.keys(context.propertyStore).forEach(path => {
                    set(block, path, context.propertyStore[path])
                })
                block = { ...block, ...cloneDeep(context.propertyStore) }
                var result = eval(formula)

                if (wasObject) {
                    // Escape quotes, handle nulls well in objects
                    result = JSON.stringify(result).slice(1, -1)
                } else if (result == null) {
                    // Don't return the string "null"
                    result = ""
                }

                string = string.replace(match, result)
            } catch (e) {
                // Yeah, something didn't work.
                // Maybe the user hasn't finished typing it?
                // Anyway, don't show the formula to the world, please
                if (!context.editor.isEditing) string = string.replace(match, "")
            }
        })
    }
    if (wasObject) {
        try {
            string = JSON.parse(string)
        } catch (e) {
            // We've done something bad. Let's just return the original
            return input
        }
    }
    return string
}

export const evaluateStyleFormulas = (context, style) => {
    const evalF = evaluateFormulas(context)
    return evalF(style)
}



// WEBPACK FOOTER //
// ./src/features/editor/formulas/evaluate.js